import { Trans, useTranslation } from 'react-i18next';

import { ModalTitleStyles as S } from './ModalTitle.styles';

export const Title = (): JSX.Element => {
  const { t } = useTranslation('trials', { keyPrefix: 'post-trial' });

  return (
    <S.Header>
      <Trans i18nKey="trials:post-trial.title" components={[<S.Emphasis />]}>
        {t('title')}
      </Trans>
    </S.Header>
  );
};
